import { render, staticRenderFns } from "./intoRoomData.vue?vue&type=template&id=1135d1e0&scoped=true"
import script from "./intoRoomData.vue?vue&type=script&lang=js"
export * from "./intoRoomData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135d1e0",
  null
  
)

export default component.exports